import * as React from 'react';
import {Helmet} from 'react-helmet';
import '/node_modules/flag-icons/css/flag-icons.min.css';

import Header from './page-layout/header';
import {ThemeProvider} from 'styled-components';
import {myTheme} from '../style/my-theme';
import {GlobalStyle} from '../style/style';
import Footer from './page-layout/footer';
import CONTENT from './content';
import AnnouncementStrip from './announcement-strip';

const Layout = ({
  children,
  title,
  description,
  imageUrl
}: {
  children: React.ReactNode;
  title?: string;
  description?: string;
  imageUrl?: string;
}) => {
  const helmetTitle = title ? title : CONTENT.HELMET.title;
  const helmetDescription = description ? description : CONTENT.HELMET.description;
  const helmetImageUrl = imageUrl ? imageUrl : CONTENT.HELMET.imageUrl;
  return (
    <ThemeProvider theme={myTheme}>
      <React.Fragment>
        <Helmet>
          {/* General tags */}
          <title>{helmetTitle}</title>
          <meta name="description" content={helmetDescription} />
          <meta name="image" content={helmetImageUrl} />

          {/* OpenGraph tags */}
          <meta property="og:title" content={helmetTitle} />
          <meta property="og:description" content={helmetDescription} />
          <meta property="og:image" content={helmetImageUrl} />

          {/* Twitter Card tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content={'@armada_js'} />
          <meta name="twitter:title" content={helmetTitle} />
          <meta name="twitter:description" content={helmetDescription} />
          <meta name="twitter:image" content={helmetImageUrl} />

          {/* Global site tag (gtag.js) - Google Analytics */}
          {process.env.NODE_ENV === 'production' ? (
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-G77PJKPG2V"></script>
          ) : null}
          {process.env.NODE_ENV === 'production' ? (
            <script>
              {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-G77PJKPG2V');`}
            </script>
          ) : null}

          {/* Mailchimp subscribe popup */}
          <script id="mcjs">
            {`
            !function(c,h,i,m,p)
            {
              ((m = c.createElement(h)),
              (p = c.getElementsByTagName(h)[0]),
              (m.async = 1),
              (m.src = i),
              p.parentNode.insertBefore(m, p))
            }
            (document,"script","https://chimpstatic.com/mcjs-connected/js/users/c5cab02c1c0a5dd0469cb98f1/7762e0db31cab6c9e6e742d20.js");
          `}
          </script>
          {/* Facebook Domain Verification */}
          {process.env.NODE_ENV === 'production' ? (
            <meta name="facebook-domain-verification" content="6l6z3s0x7cmselkfxmzc0yjbaxg2x7" />
          ) : null}
          {/* Meta Pixel Code */}
          <script>
            {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1863742947152406');
            fbq('track', 'PageView');
            `}
          </script>
          <noscript>
            {`<img
              height="1"
              width="1"
              style={{display: 'none'}}
              src="https://www.facebook.com/tr?id=1863742947152406&ev=PageView&noscript=1"
            />`}
          </noscript>
          {/* End Meta Pixel Code */}

          {/* FIENTA ticket sales */}
          <script type="text/javascript" src="https://fienta.com/embed.js"></script>
        </Helmet>
        <GlobalStyle />
        <AnnouncementStrip />
        <Header />
        {children}
        <Footer />
      </React.Fragment>
    </ThemeProvider>
  );
};

export default Layout;
